import { useCallback, useEffect, useRef, useState } from "react"
import { Col, Container, Form, Row } from "react-bootstrap"
import SpecimenIdInput from "../FormattedInputs/SpecimenIdInput"
import { useEffectAfterMount } from "../../utils/hooks"

export interface InputSpecimenIdProps {
  sampleId?: string
  required?: boolean
  disabled?: boolean
  validate?: boolean | undefined
  onChange: (value: string, isValid: boolean) => void
}

const InputSpecimenId = (props: InputSpecimenIdProps) => {
  const { sampleId = "", required = false, disabled = false } = props

  const [id, setId] = useState(sampleId)
  const [idRepeat, setIdRepeat] = useState(sampleId)
  const [isIdValid, setIdValid] = useState(true)
  const [isIdRepeatValid, setIdRepeatValid] = useState(true)
  const refObj = useRef({ onChange: props.onChange })

  const isIdFormatValid = (value: string, alowEmpty: boolean = false) => {
    return value.length === 0 ? alowEmpty : new RegExp(`^[A-Za-z]{1}[0-9]{9}$`).test(value)
  }

  const isValid = useCallback(() => {
    return isIdFormatValid(id, !required) && id === idRepeat
  }, [id, idRepeat, required])

  useEffect(() => {
    refObj.current.onChange(id, isValid())
  }, [id, isValid])

  useEffectAfterMount(() => {
    if (props.validate !== undefined) {
      setIdValid(isIdFormatValid(id, !required))
      setIdRepeatValid(id === idRepeat)
    }
  }, [props.validate, required, id, idRepeat])

  return (
    <Container fluid className='mt-3'>
      <Row>
        <Col>
          <h6 className={required ? "required" : ""}>Specimen ID#</h6>
          <SpecimenIdInput
            disabled={disabled}
            value={id}
            isValid={() => isIdValid}
            onChange={value => setId(value)} />
        </Col>
        <Col>
          <h6 className={required ? "required" : ""}>Repeat Specimen ID#</h6>
          <SpecimenIdInput
            disabled={disabled}
            value={idRepeat}
            isValid={() => isIdRepeatValid}
            onChange={value => setIdRepeat(value)} />
        </Col>
        <Col></Col>
        <Col></Col>
        <Col></Col>
      </Row>
      <Row>
        <Col>
          {!isIdValid && <Form.Control.Feedback className="d-block" type="invalid">
            {`The SpecimenID must start with an Alpha character followed by 9 digits.`}
          </Form.Control.Feedback>}
          {!isIdRepeatValid && <Form.Control.Feedback className={`d-block ${isIdValid ? "" : "mt-0"}`} type="invalid">
            The two Specimen ID entries must match each other.
          </Form.Control.Feedback>}
        </Col>
      </Row>
    </Container>
  )
}

export default InputSpecimenId
